import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const XBigIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5.761959 4.387792 L 8.740458 0.999958 L 8.03475 0.999958 L 5.447333 3.940933 L 3.382292 0.999958 L 0.999958 0.999958 L 4.123408 5.447625 L 0.999958 8.999958 L 1.705675 8.999958 L 4.436375 5.893458 L 6.617625 8.999958 L 8.999958 8.999958 L 5.761959 4.387792 Z M 4.795042 5.486667 L 4.478084 5.0435 L 1.960171 1.520546 L 3.044296 1.520546 L 5.076958 4.36475 L 5.392541 4.807917 L 8.034417 8.50475 L 6.950292 8.50475 L 4.795042 5.486667 Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const XBigIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M 5.761959 4.387792 L 8.740458 0.999958 L 8.03475 0.999958 L 5.447333 3.940933 L 3.382292 0.999958 L 0.999958 0.999958 L 4.123408 5.447625 L 0.999958 8.999958 L 1.705675 8.999958 L 4.436375 5.893458 L 6.617625 8.999958 L 8.999958 8.999958 L 5.761959 4.387792 Z M 4.795042 5.486667 L 4.478084 5.0435 L 1.960171 1.520546 L 3.044296 1.520546 L 5.076958 4.36475 L 5.392541 4.807917 L 8.034417 8.50475 L 6.950292 8.50475 L 4.795042 5.486667 Z" />
        </SvgIcon>
    );
};
